import {createAsyncThunk} from '@reduxjs/toolkit'

import {PopupSize} from '@web/core/constants'
import {ORDER_DEV} from '@web/core/urls'
import {changeBrowserLocation, openNewTab, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const POPUP_KEY = 'CLAIM_RETURN_REQUEST'

type NavigateToSaleHistoryParam = NavigationTypeSelectableParam &
    LocationChangeHistoryParam & {
        orderNo: string
        productOrderNo: string
    }

/**
 * 반품 요청
 * 주문형 BE에서 관리중인 claim 페이지로 이동시에는 MO에서 새탭으로 열도록 처리
 * https://oss.fin.navercorp.com/Product-Planning/Order_QA/issues/11753
 **/
const navigateToClaimReturnRequest = createAsyncThunk<string | unknown, NavigateToSaleHistoryParam, ThunkApi<unknown>>(
    'navigateTo/claimReturnRequest',
    ({forceLocationChange, orderNo, productOrderNo}) => {
        const url = `${ORDER_DEV}/o/claim/return/request/${orderNo}/${productOrderNo}/pay`

        if (isMobile) {
            openNewTab({url})
        } else if (forceLocationChange) {
            changeBrowserLocation({url, type: 'PUSH'})
        } else {
            openPopup({
                key: POPUP_KEY,
                url,
                title: '반품 요청',
                size: {
                    width: PopupSize.common.width,
                    height: PopupSize.common.height,
                },
            })
        }
    },
)

export default navigateToClaimReturnRequest
